import {j as jsxRuntimeExports}from'../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js';import {Tooltip}from'@lemon-fe/kits';const style = { fontSize: '14px', color: '#333' };
// 使用 Map 存储每个 traceId 的复制状态
const copiedStateMap = new Map();
/**
 * 复制文本到剪切板
 * @param value - 要复制的文本
 */
const copyToClipboard = (value) => {
    const textareaEl = document.createElement('textarea');
    textareaEl.setAttribute('readonly', 'readonly'); // 防止手机上弹出软键盘
    textareaEl.value = value;
    document.body.appendChild(textareaEl);
    // 方法用于选择该元素中的文本。
    textareaEl.select();
    // 拷贝当前选中内容到剪贴板。启用这个功能的条件因浏览器不同而不同，而且不同时期，其启用条件也不尽相同。使用之前请检查浏览器兼容表，以确定是否可用。
    document.execCommand('copy');
    document.body.removeChild(textareaEl);
};
// 错误信息函数，支持复制功能
const errorMessage = (params) => {
    const { msg, traceId } = params;
    // 页面仅展示日志 ID 后六位，复制时仍使用完整 ID 便于检索日志。
    const displayTraceId = traceId && traceId.length > 6 ? `...${traceId.slice(-6)}` : traceId;
    // 通过 traceId 找到对应的 Tooltip overlay
    const findTooltipOverlay = (traceId) => {
        // 使用 overlayClassName 来精确定位对应的 tooltip
        const className = `tooltip-trace-${traceId.replace(/[^a-zA-Z0-9]/g, '-')}`;
        const tooltip = document.querySelector(`.${className}`);
        if (tooltip) {
            const inner = tooltip.querySelector('.ant-tooltip-inner');
            return inner;
        }
        return null;
    };
    const handleCopy = (e) => {
        e.stopPropagation();
        if (traceId) {
            copyToClipboard(traceId);
            copiedStateMap.set(traceId, true);
            // 更新图标和 Tooltip
            const svgElement = e.currentTarget;
            const pathElement = svgElement.querySelector('path');
            if (pathElement) {
                // 更新为成功图标
                pathElement.setAttribute('d', 'M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z');
                svgElement.style.color = '#52c41a';
                svgElement.removeAttribute('onClick');
                // 更新 Tooltip title（通过查找对应的 Tooltip overlay 元素）
                setTimeout(() => {
                    const tooltipOverlay = findTooltipOverlay(traceId);
                    if (tooltipOverlay) {
                        tooltipOverlay.textContent = '复制成功';
                    }
                }, 100);
            }
            // 等待5秒后恢复
            const timer = setTimeout(() => {
                // 删除状态而不是设置为false，避免内存泄漏
                copiedStateMap.delete(traceId);
                if (svgElement && pathElement) {
                    pathElement.setAttribute('d', 'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z');
                    svgElement.style.color = '#1890ff';
                    svgElement.onclick = handleCopy;
                    // 恢复 Tooltip title
                    setTimeout(() => {
                        const tooltipOverlay = findTooltipOverlay(traceId);
                        if (tooltipOverlay) {
                            tooltipOverlay.textContent = '复制';
                        }
                    }, 100);
                }
            }, 5000);
            // 存储 timer 以便清理
            svgElement.__copyTimer = timer;
        }
    };
    const isCopied = traceId ? copiedStateMap.get(traceId) || false : false;
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx("span", { style: style, children: msg }), traceId && (jsxRuntimeExports.jsxs("div", { style: style, children: [jsxRuntimeExports.jsxs("span", { style: { marginRight: '6px', ...style }, children: [window.$t({ id: 'ZqELxR', defaultMessage: '日志ID' }), "\uFF1A", displayTraceId] }), jsxRuntimeExports.jsx(Tooltip, { title: isCopied ? '复制成功' : '复制', overlayInnerStyle: { pointerEvents: 'none' }, overlayClassName: `tooltip-trace-${traceId.replace(/[^a-zA-Z0-9]/g, '-')}`, onOpenChange: (visible) => {
                            // 当 Tooltip 显示时，根据当前状态动态更新 title
                            if (visible && traceId) {
                                setTimeout(() => {
                                    const currentCopied = copiedStateMap.get(traceId) || false;
                                    const tooltipOverlay = findTooltipOverlay(traceId);
                                    if (tooltipOverlay) {
                                        tooltipOverlay.textContent = currentCopied ? '复制成功' : '复制';
                                    }
                                }, 0);
                            }
                        }, children: jsxRuntimeExports.jsx("svg", { viewBox: "64 64 896 896", focusable: "false", width: "14", height: "14", fill: "currentColor", style: {
                                cursor: 'pointer',
                                color: isCopied ? '#52c41a' : '#1890ff',
                                verticalAlign: 'middle',
                            }, onClick: isCopied ? undefined : handleCopy, "data-trace-id": traceId, children: isCopied ? (jsxRuntimeExports.jsx("path", { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" })) : (jsxRuntimeExports.jsx("path", { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" })) }) })] }))] }));
};export{copyToClipboard,errorMessage as default};//# sourceMappingURL=error-message.js.map
